import {
    archiveFilesPrompt, copyTextToClipboard,
    createElemWithClasses,
    delay,
    deleteFilesPrompt,
    freeTier,
    getItem,
    groupBy,
    initUtils,
    mfetch,
    passwordPrompt,
    pinPrompt,
    resharePrompt,
    setupClipboardButtons,
    showFreeTierDepletedPrompt, showGoodie,
    showPasswordErrorPrompt,
    showTooltip,
    unverifiedDownloadPrompt,
    updateFileCounters,
    upgradePrompt
} from "./utils";
import {
    convertStringToArrayBufferView,
    decryptSymmetricKey,
    encryptMessage,
    extractSecretUsingLocalSecretKey,
    getRsaAlgorithm,
    getSecretKey,
    getSymmetricAlgorithm
} from "./crypto";
import {FileData, getUppy, isUserView, setupDropzone, setupPluginLink} from "./upload";
import {reshareFunction, setupNewTable} from "./filelist";
import {setupLogin} from "./login";
import {setupRegisterUser} from "./register";
import {deleteContact, setupContacts} from "./contact";
import {setupVerification} from "./verification";
import {setupResetPassword} from "./reset";
import {setupForgotPassword} from "./forgot";
import {setupDeleteAccount} from "./delete-account";
import {createPopper} from "@popperjs/core";
import {downloadMultipleFiles, mainDownload} from "./download";
// import bootstrap from "bootstrap";
import {setupReceiveSettings} from "./receive";
import {setupSettingsForms} from "./settings";
// import {setupSpaces} from "./spaces";
// @ts-ignore
import * as bootstrap from 'bootstrap';
import {getCurrentLang, localizeSecret, translate} from "./translations";
import {Placement} from "@popperjs/core/lib/enums";
// import {setupDiscoverable} from "./discoverable";


async function decryptWithSymmetricKey(key: CryptoKey, algorithm: Algorithm, ciphertext: string) {
    if(!ciphertext) {
        return null;
    }
    const sencryptedFilename = atob(ciphertext);

    let arraybuffer = convertStringToArrayBufferView(sencryptedFilename);

    const decryptedFilename = await window.crypto.subtle.decrypt(
        algorithm,
        key,
        arraybuffer
    );
    return new TextDecoder("utf-8").decode(decryptedFilename);
}


async function extractSymmetricKey(row: FileData, privateKey: CryptoKey): Promise<{ algorithm: Algorithm, key: CryptoKey }> {

    let secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, privateKey);
    let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link

    return decryptSymmetricKey(hash)
}


function showError(element: HTMLElement, error: string, placement?: Placement) {

    document.querySelectorAll('.popper-error-message').forEach(elem => {
        elem.remove()
    })
    if(!placement) {
        placement = 'bottom-start'
    }

    const tooltip = createElemWithClasses('div', ['popper-error-message'])
    tooltip.innerText = error;
    document.body.appendChild(tooltip)
    let message = createPopper(element, tooltip, {
        placement: placement,
    });
    setInterval(() => {
        message.destroy();
        tooltip.remove()
    }, 5000)
}

function removeExtension(filename: string){
    return filename.substring(0, filename.lastIndexOf('.')) || filename
}

function insertAfter(newNode: HTMLElement, existingNode: HTMLElement) {
    existingNode.parentNode!.insertBefore(newNode, existingNode.nextSibling);
}

function editName(element: HTMLElement, db: IDBDatabase, glob: NestedFileArray) {

    const li = element.parentElement as HTMLElement;
    const name = li.querySelector('.inline-label')! as HTMLElement
    const parent = name.parentElement as HTMLElement

    const textElement = name.childNodes[0]


    let value = textElement ? name.childNodes[0]!.textContent!.trim() : ""

    let input = document.createElement('input')
    input.classList.add("transfer-header-input")
    input.value = value
    input.type = 'text'

    insertAfter(input, parent.querySelector('.inline-label')!)

    // parent.appendChild(input);
    name.style.display = 'none'
    input.focus()

    let fileNameWithoutExtensiion = removeExtension(input.value)
    let selectionLength = fileNameWithoutExtensiion.length
    // input.select();
    input.setSelectionRange(0, selectionLength)


    input.addEventListener('keypress', (e2) => {
        if (e2.key === 'Enter' || e2.key === 'Escape') {
            e2.preventDefault()
            input.blur()
        }
    })



    input.addEventListener('blur',  (e2) => {
        const target = e2.target as HTMLInputElement;
        let inputValue = input.value.trim();
        if (inputValue === "") {
            name.style.display = 'block'
            target.remove()
            return
        }
        // if(messageButton) {
        //     messageButton.style.display = 'block'
        // }

        const row = element.dataset!

        // const path = row.path!.split('/')
        const level = parseInt(row.level!)

        let error: any = undefined;

        const p = new Promise((resolve, reject) => {
            const onerror = () => {
                reject(`${inputValue} could not be changed`)
            }

            const oncomplete = async (ev: any) => {
                let privateKey = ev.target.result;
                const secret = await extractSecretUsingLocalSecretKey((row.encryptedkey as string), privateKey)
                let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
                const split = hash.split('-');
                const counter = new Uint8Array(atob(split[0]).split(",").map(x => parseInt(x)));

                const keydata = JSON.parse(atob(split[1]));

                const algorithm = getSymmetricAlgorithm(counter);

                let transferKey = await window.crypto.subtle.importKey('jwk',
                    keydata,
                    algorithm,
                    false,
                    keydata.key_ops
                );

                const inputValueCleaned = inputValue.replace(/[/\\?%*:|"<>]/gi, '');
                const errorMessage = 'Please do not use the following characters: / \ ? % * : | < >'

                if (inputValueCleaned.length === 0) {
                    reject(errorMessage)
                    return
                }
                if (inputValueCleaned !== inputValue) {
                    reject(errorMessage)
                    return
                }

                if (level === 0) {
                    let encryptedTransferName = await encryptMessage(new TextEncoder().encode(inputValueCleaned), transferKey, algorithm)


                    let arr = Array.from(new Uint8Array(encryptedTransferName))
                    const b64encryptedName = btoa(String.fromCharCode(...arr));

                    resolve({
                        url: '/files/transfer/rename',
                        body: {
                            prefix: row.prefix,
                            transfer_name: b64encryptedName
                        }
                    })
                } else {
                    const pathInfo = element.dataset.path!.split('/')
                    const [oldName, suffix] = pathInfo[level + 1].split(SEPARATOR)
                    if (oldName === inputValue) {
                        reject('') // no file name change
                        return
                    }
                    pathInfo[level + 1] = inputValue + SEPARATOR + suffix
                    let newPath = pathInfo.slice(2, ).join('/'); // pathInfo.join('/')
                    if(newPath.indexOf(SEPARATOR) > 0) {
                        newPath = newPath.split(SEPARATOR)[0]
                    }
                    const newName = inputValue
                    let encryptedFileName = await encryptMessage(new TextEncoder().encode(newName), transferKey, algorithm)

                    let arr = Array.from(new Uint8Array(encryptedFileName))
                    const b64encryptedFileName = btoa(String.fromCharCode(...arr));
                    let encryptedFilePath = await encryptMessage(new TextEncoder().encode(newPath), transferKey, algorithm)
                    arr = Array.from(new Uint8Array(encryptedFilePath))
                    const b64encryptedFilePath = btoa(String.fromCharCode(...arr));
                    resolve({
                        url: '/files/filename/rename',
                        body: {
                            prefix: row.prefix,
                            name: row.name,
                            filepath: b64encryptedFilePath,
                            filename: b64encryptedFileName
                        }
                    })
                }


            }
            if (db) {
                getItem(db, 'key', oncomplete, onerror)
            }
        })


        p.then((result: any) => {
            mfetch(result.url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(result.body)
            }).then((r) => {
                return r.status === 200;
            })
        })
        .catch((err) => {
            error = err;
        })
        .finally(()=> {
            name.style.display = 'block'

            target.remove()
            if (error) {
                showError(name, error)
            } else {
                if(textElement) {
                    textElement.textContent = inputValue;
                } else {
                    name.append(inputValue);
                    const counter = name.nextElementSibling! as HTMLElement;
                    counter.innerText = ' - ' + counter.innerText
                }

                const subElem = getSubFileArray(element.dataset.path!.split('/'), glob)

                if(subElem.children.length === 0) {
                    inputValue = inputValue  + SEPARATOR + element.dataset.name
                }
                if(level > 0) {
                    subElem.name = inputValue
                }

                let newPath = element.dataset.path!.split('/')
                if(level === 0) {
                    // newPath = newPath.slice(1)
                } else {
                    newPath[level + 1] = inputValue
                }
                element.dataset.path = newPath.join('/')
                // element.id = newPath.join('/')
            }
        })
    })
}


function renderUploadBUtton(isUserView: boolean, tableMode: HTMLInputElement, mainPanel: HTMLDivElement, contact: HTMLElement) {
    if (isUserView || tableMode.value === 'outbox') {
        const upload = createElemWithClasses('button', ['chat-upload'])
        upload.id = 'open-uppy-button';
        const inner = createElemWithClasses('span')
        upload.append(inner)
        mainPanel.append(upload)
        inner.innerText = translate('Upload')
        upload.addEventListener('click', () => {
            getUppy().getPlugin('Dashboard').openModal()
            if (tableMode.value !== 'outbox') {
                const labelTo = document.getElementById('uppy-label-to') as HTMLLIElement
                if (labelTo) {
                    const input = labelTo.querySelector('input') as HTMLInputElement
                    labelTo.classList.remove('d-none')
                    labelTo.classList.add('d-block')
                    input.readOnly = true;
                    input.disabled = true;
                    input.value = contact.innerText
                }
            }
        })
    }
    if (tableMode.value === 'inbox') {
        const upload = createElemWithClasses('button', ['chat-upload'])
        const helpModal = document.getElementById('helpModal') as HTMLElement
        if (helpModal) {

            const textElement = document.getElementById('receive-help-text')! as HTMLElement
            const button = createElemWithClasses('a', ['cursor-pointer'])
            button.innerText = textElement.innerText


            button.addEventListener('click', () => {
               showHelp()

            })

            upload.appendChild(button)
        }

        mainPanel.append(upload)

    }
}

export async function getData(db: IDBDatabase, searchTerm?: string) {
    let explorer = document.getElementById('transfer-file-list');

    if(!explorer) {
        return
    }


    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    let t0 = performance.now();
    const r = await mfetch("/files/list/" + tableMode.value + document.location.search)
    let t1 = performance.now();
    console.log("Call to fetch data took " + (t1 - t0) + " milliseconds.")
    const data = await r.json() as Array<FileData>;

    /**
     * Inner decrypt loop for filenames
     */
    async function _decryptItems(privateKey: CryptoKey) {
        let grouped: any = groupBy(data, (x: FileData) => x.prefix)
        for (let group of Object.keys(grouped)) {
            const row = grouped[group][0]
            const {algorithm, key} = await extractSymmetricKey(row, privateKey);

            for (let i = 0; i < grouped[group].length; i++) {
                const file = grouped[group][i]
                let filename: string = await decryptWithSymmetricKey(key, algorithm, file.encrypted_filepath || file.encrypted_filename) as string;
                if(filename.startsWith('/')) {
                    filename = filename.slice(1)
                }
                grouped[group][i].filename = filename
                grouped[group][i].transfer_name = await decryptWithSymmetricKey(key, algorithm, file.encrypted_transfername);
                grouped[group][i].message = await decryptWithSymmetricKey(key, algorithm, file.encrypted_message);
            }
        }
    }
    t0 = performance.now();

    await new Promise(((resolve, reject) => {
        if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key
            const onerror = () => {
                reject('No key available')
            }
            const oncomplete = async (event: any) => {
                let key = event.target.result;
                try {
                    await _decryptItems(key);
                    resolve(data)
                } catch (e) {
                    reject('Could not decrypt items')
                }
            }
            if (db) {
                getItem(db, 'key', oncomplete, onerror)
            } else {
                const callback = async (modalPassword: string) => {
                    let key = await getSecretKey(modalPassword);
                    if (key) {
                        await _decryptItems(key)
                        resolve(data)
                        // await _decryptTransfers(key);
                    } else {
                        showPasswordErrorPrompt()
                        reject('Could not decrypt items')
                    }
                };
                passwordPrompt(callback)
            }
        } else {
            // let hash = document.location.hash;
            // for (let i = 0; i < data.length; i++) {
            //     const row = data[i]
            //     let encryptedFilename = row.encrypted_filepath
            //     if(!encryptedFilename || encryptedFilename === 'null') {
            //         encryptedFilename = row.encrypted_filename
            //     }
            //     let filename = await getMatchingFileName(hash, row.name, encryptedFilename);
            //     const decryptButton = document.getElementById(`${row.prefix}-${row.name}`) as HTMLButtonElement
            //     decryptButton.innerHTML = filename;
            //     if(i === 0) {
            //         const transferName = document.getElementById(row.prefix)
            //         if (transferName.innerText === 'Transfer') {
            //             continue
            //         }
            //         let filename = await getMatchingFileName(hash, row.name, row.encrypted_transfername);
            //         transferName.innerHTML = filename;
            //
            //     }
            // }
        }
    }))


    t1 = performance.now();
    console.log("Call to decrypt took " + (t1 - t0) + " milliseconds.")

    //clean up explorer
    // const newExplorer = explorer.cloneNode(false)
    // explorer.replaceWith(newExplorer);
    const parent = document.getElementById('transfers-main')
    explorer = document.getElementById('transfer-file-list')!;
    explorer.remove()
    const newExplorer = createElemWithClasses('div')
    newExplorer.id = 'transfer-file-list'



    parent!.appendChild(newExplorer)
    explorer = document.getElementById('transfer-file-list')!;

    let glob = prepareFileTree(data);
    // explorer.innerText = '';

    const helpElements = document.querySelectorAll('.empty-state')
    for (let h of Array.from(helpElements)) {
        (h as HTMLElement).style.display = 'none'
    }

    if (glob["children"].length === 0) { //empty, no files

        const actionRow = document.querySelector('.details-actions') as HTMLElement;
        if(actionRow) {
            actionRow.innerText = '';
        }

        const tableMode = document.getElementById('table_mode')! as HTMLInputElement;

        const helpElement = document.getElementById(`empty-state-${tableMode.value}`)
        // let help = createElemWithClasses('div')
        // if(helpElement) {
        //     helpElement.style.display = 'block'
        // } else {

            const mainPanel = createPanel();
            mainPanel.classList.add('main')
            explorer.appendChild(mainPanel);
            const isUserView = !(tableMode.value === 'inbox' || tableMode.value === 'drive' || tableMode.value === 'outbox' || tableMode.value === 'external_download');
            const contact = document.querySelector('.sidebar-button.active') as HTMLElement
            if (isUserView) {
                renderContactHeader(contact);

            }

            const noMessages = createElemWithClasses('div', ['no-messages'])
            noMessages.innerText = translate('There are no active files yet. Start the conversation by uploading files.')
        if(helpElement){
            noMessages.innerHTML = helpElement.innerHTML
        }
            mainPanel.appendChild(noMessages);

            renderUploadBUtton(isUserView, tableMode, mainPanel, contact);

            explorer.appendChild(mainPanel);

        // }
        // explorer.style.gridAutoColumns = '100%'
        // explorer.appendChild(helpElement);
        return
    }

    createMainPanel(explorer, glob);
    const t2 = performance.now();
    console.log("Call to createMainPanel took " + (t2 - t1) + " milliseconds.")

    // let path: string[] = [];
    const handleClick = (e: MouseEvent) => {
        let target = e.target as HTMLElement;

        const panel = target.closest('div.panel')!;

        if(target!.classList.contains('message-link')) {
            return;
        }

        target = target.closest('label')!;

        if(!target) {
            const actionMenu = document.querySelector('.priority-menu-inner.open');
            if(actionMenu) {
                actionMenu.classList.remove('open')
            }
            return
        }

        if(target.tagName.toLowerCase() === 'label')  {
            if(!e.shiftKey || panel.classList.contains('main')) {

                panel.querySelectorAll('label.selected').forEach((item) => {
                    if(item !== target) {
                        item.classList.remove('selected');
                    }
                })
            }

            target.classList.add('selected');

            const selection = panel.querySelectorAll('label.selected');

            let nextPanel = panel!.nextSibling as HTMLDivElement;
            let allPanels = Array.from(explorer!.querySelectorAll('.panel'));
            const currentPanelIndex = allPanels.indexOf(panel!);
            let nextPanels = allPanels.slice(currentPanelIndex + 1)

            nextPanels.forEach(elem => {
                elem.remove()
            })

            if (selection.length === 1) {

                const level = parseInt(target.dataset.level as string);

                const path = target.dataset.path!.split('/');
                let items = getSubFileArray(path, glob);
                let newPanel;
                if (items.children && items.children.length > 0) {
                    nextPanel = createPanel();
                    explorer!.appendChild(nextPanel)
                    nextPanel.dataset.name = items.name;
                    nextPanel.dataset.path = JSON.stringify(path);
                    newPanel = renderListPanel(items, path, level + 1);
                    nextPanel.appendChild(newPanel);
                }
            }

            // renderDetailPanel(explorer!);

            // explorer!.scrollTo(explorer!.scrollLeft + 100, 0);
            explorer!.scrollTo(explorer!.scrollLeft + panel.getBoundingClientRect().width, 0);

            const backButton = document.getElementById('file-list-back-button') as HTMLAnchorElement;
            if(backButton) {
                if(allPanels.length > 0 && isMobile()) {
                    backButton.style.display = 'block'

                }
            }
        }
    }

    // explorer.addEventListener('scroll')   // todo
    explorer.addEventListener('click', handleClick);
    explorer.addEventListener('dblclick', () => { triggerEvent('arcano-explorer:download') });
    explorer.addEventListener('arcano-explorer:update', () => {
        getData(db).then(() => {})
    });
    explorer.addEventListener('arcano-explorer:search', (e) => {
        const searchTerm = (e as CustomEvent).detail.term
        if (searchTerm) {
            const filteredData = data.filter(x => {
                const fileNameMatches = x.filename!.toLowerCase().indexOf(searchTerm) >= 0;
                const transferNameMatches = x.transfer_name && x.transfer_name!.toLowerCase().indexOf(searchTerm) >= 0;
                const prefixMatches = x.prefix.indexOf(searchTerm) >= 0;
                const senderMatches = x.from_raw.indexOf(searchTerm) >= 0;
                const receiverMatches = x.to_raw.indexOf(searchTerm) >= 0;
                return fileNameMatches || transferNameMatches || prefixMatches || senderMatches || receiverMatches;
            })
            glob = prepareFileTree(filteredData);
        } else { // empty
            glob = prepareFileTree(data);
        }
        explorer!.innerText = '';
        createMainPanel(explorer!, glob);
    });
    explorer.addEventListener('arcano-explorer:archive', () => {
        let subsequentlySelectedFiles = getSelectionRecursive(explorer!, glob)
        const files = subsequentlySelectedFiles.map(x => { return x.value }) as Array<FileData>;
        if(files.length > 0) {
            archiveFilesPrompt(function (res) {
                if (res) {
                    processFiles(files, "/file/archive/", "PUT", db);
                    getData(db).then(() => {
                    })
                }
            });
        }
    });
    explorer.addEventListener('arcano-explorer:unarchive', () => {
        let subsequentlySelectedFiles = getSelectionRecursive(explorer!, glob)
        const files = subsequentlySelectedFiles.map(x => { return x.value }) as Array<FileData>;
        if(files.length > 0) {
            const modalElement = document.getElementById('unarchiveConfirmModal')!;
            let myModal = new bootstrap.Modal(modalElement)
            document.getElementById('unarchiveConfirmButton')!.addEventListener('click', function () {

                let daysToLive = '7';
                let downloadLimit = '100';

                let downloadLimitElement = document.querySelector('#unarchiveConfirmModal #expiry-download-input') as HTMLInputElement;
                if (downloadLimitElement) {
                    downloadLimit = downloadLimitElement.value
                }

                let daysToLiveElement = document.querySelector('#unarchiveConfirmModal #expiry-days-input') as HTMLInputElement;
                if (daysToLiveElement) {
                    daysToLive = daysToLiveElement.value
                }
                if (!downloadLimit) {
                    downloadLimit = '0'
                }

                processFiles(files, "/file/unarchive/" + daysToLive + "/" + downloadLimit + "/", 'PUT', db);
                myModal.hide()
                myModal.dispose()
                getData(db).then(() => {
                })
            }, {once: true});

            myModal.show()
        }
    });

    explorer.addEventListener('arcano-explorer:reshare', async () => {
        let subsequentlySelectedFiles = getSelectionRecursive(explorer!, glob)
        const files = subsequentlySelectedFiles.map(x => { return x.value }) as Array<FileData>;
        if(files.length === 0) {
            return
        }

        async function callback(result: boolean) {
            if(result) {
                // let fd = new FormData(document.getElementById('reshare-infos'))

                const receiverUid = (document.getElementById('reshare-contact') as HTMLInputElement).value;
                const senderUid = (document.getElementById('sender-uid') as HTMLInputElement).value;
                const response = await mfetch('/key/' + receiverUid)
                const userData = await response.json()
                const publicKeyJwk = JSON.parse(userData.publicKey);
                const rsaAlgo = getRsaAlgorithm();

                const publicKey = await window.crypto.subtle.importKey('jwk',
                            publicKeyJwk,
                            rsaAlgo,
                            false,
                            publicKeyJwk.key_ops)

                if (db) {
                    const oncomplete = async (ev: any) => {
                        let key = ev.target.result;
                        await reshareFunction(files, key, userData, publicKey, senderUid, receiverUid);
                    }
                    const onerror = () => {}

                    getItem(db, 'key', oncomplete, onerror)
                } else {

                    const callback = async (modalPassword: string) => {
                        let key = await getSecretKey(modalPassword);
                        if (key) {
                            await reshareFunction(files, key, userData, publicKey, senderUid, receiverUid);
                        } else {
                            showPasswordErrorPrompt()
                        }
                    };
                    passwordPrompt(callback)
                }
            }
        }
        //
        if (document.location && document.location.pathname.indexOf('/external_download') >= 0) {
            console.log('todo remove this function here')
        } else {
            // we can ask who in the org may get the file
            mfetch('/contacts/list/reshare')
                .then(response => response.json())
                .then(contacts => {
                    const options = contacts.users.map((x: any) => `<option value="${x.id}"'>${x.fullname} (${x.email})</option>`).join('\n')
                    resharePrompt(callback, options)
                })
        }
    })

    explorer.addEventListener('arcano-explorer:email-link', () => {
        const forceSingleFile = false
        const selectedTransfer = explorer!.querySelector('label.selected') as HTMLElement
        if(!selectedTransfer) {
            return
        }
        const row = selectedTransfer!.dataset;

        let subject = document.getElementById('email_subject') as HTMLInputElement;
        let body = document.getElementById('email_body') as HTMLInputElement;
        let footer = document.getElementById('email_footer') as HTMLInputElement;

        const onerror = () => { /* iognore */ }

        const oncomplete = async (event: any) => {

            let key = event.target.result;
            let secret = await extractSecretUsingLocalSecretKey((row.encryptedkey as string), key)
            if (forceSingleFile && secret.includes('?prefix=')) {
                // inject the 'name' as a query_string arg into the secret
                const prefixIndex = secret.indexOf('?prefix=');
                const nameQS = "name=" + row.name + "&";
                secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
            }

            // localize secret
            const localizedSecretLink = localizeSecret(secret)

            const mail_subject = encodeURIComponent(subject.value);
            let mail_secret = encodeURIComponent(body.value.replace('\n', '\r\n'))  + '%0D%0A' + encodeURIComponent(localizedSecretLink);
            const e = document.getElementById('expiry-days-input') as HTMLSelectElement;
            const text = e. options[e. selectedIndex]. text;
            mail_secret += '%0D%0A%0D%0A' + encodeURIComponent(footer.value.replace('\n', '\r\n')) + encodeURIComponent(text)
            mail_secret += '%0D%0A%0D%0A' + encodeURIComponent('ARCANO.\nStay safe') + '%0D%0A' + encodeURIComponent('https://arcano.app');

            const mailLink = document.createElement("a") as HTMLAnchorElement;
            mailLink.href = "mailto:?subject=" + mail_subject + "&body=" + mail_secret;
            mailLink.click();
            mailLink.remove()

        }
        async function callback(modalPassword: string) {
            let key = await getSecretKey(modalPassword);
            if (key) {
                let secret = await extractSecretUsingLocalSecretKey((row.encryptedkey as string), key)
                if (forceSingleFile && secret.includes('?prefix=')) {
                    // inject the 'name' as a query_string arg into the secret
                    const prefixIndex = secret.indexOf('?prefix=');
                    const nameQS = "name=" + row.name + "&";
                    secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
                    const mail_subject = encodeURIComponent(subject.value);
                    const mail_secret = encodeURIComponent(body.value + secret);
                    const mailLink = document.createElement("a") as HTMLAnchorElement;
                    mailLink.href = "mailto:?subject=" + mail_subject + "&body=" + mail_secret;
                    mailLink.click();
                    mailLink.remove()
                }

            } else {
                showPasswordErrorPrompt()
            }
        }
        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        } else {
            passwordPrompt(callback)
        }



        console.log('email')
    })
    explorer.addEventListener('arcano-explorer:delete', () => {
        let subsequentlySelectedFiles = getSelectionRecursive(explorer!, glob)
        const files = subsequentlySelectedFiles.map(x => x.value) as Array<FileData>;
        if(files.length > 0) {
            deleteFilesPrompt(function (res) {
                if (res) {
                    processFiles(files, "/file/delete/", 'DELETE', db)
                    //todo
                    // for(let file of subsequentlySelectedFiles) {
                    //     const path = [file.value!.transfer_name || ('Transfer ' + file.value!.prefix), ...file.value!.filename!.split('/')]
                    //     deleteSubFileArray(path, glob)
                    // }
                }
            })
        }
    })

    explorer.addEventListener('arcano-explorer:rename', () => {
        const explorer = document.getElementById('transfer-file-list');
        if(explorer) {
            let selected = explorer.querySelectorAll('.panel .selected')
            if(selected.length > 0) {
                const [lastItem] = Array.from(selected).slice(-1) as Array<HTMLElement>
                editName(lastItem, db, glob)
                // getData(db).then(() => {})
            }
        }

    })
    explorer.addEventListener('arcano-explorer:download', () => {

        let subsequentlySelectedFiles = getSelectionRecursive(explorer!, glob)
        const files = subsequentlySelectedFiles.map(x => x.value) as Array<FileData>;
        if(files.length === 0) {
            return
        }
        if (files.length !== 1) {
            downloadMultipleFiles(db, files)
            return
        }

        const row = files[0]

        let isUnverified = row.verified.toString() === 'false';
        if (isUnverified) {
            const callback = (result: boolean) => {
                if (result) {
                    execute()
                }
            };

            if (freeTier()) {
                unverifiedDownloadPrompt(callback)
            } else {
                showFreeTierDepletedPrompt()
            }

        } else {
            execute()
        }

        function execute() {
            if (row.password_hash === 'None') {
                if (freeTier()) {
                    mainDownload(db, row).then(function () {});
                } else {
                    showFreeTierDepletedPrompt()
                }
            } else {
                const callback = (passPhrase: string) => {
                    if (passPhrase !== undefined) {

                        mainDownload(db, row, passPhrase).then(function () {
                        })
                    }
                };

                if (freeTier()) {
                    pinPrompt(callback)
                } else {
                    showFreeTierDepletedPrompt()
                }
            }
        }

    })
    if(searchTerm) {
        const searchInput = document.getElementById('search-input') as HTMLInputElement;
        searchInput.value = searchTerm;
        triggerEvent('arcano-explorer:search', {term: searchTerm})
    }

}

function getSelectionRecursive(explorer: HTMLElement, glob: NestedFileArray): Array<NestedFileArray> {
    const selection = explorer.querySelectorAll('label.selected')
    if(selection.length === 0) {
        return [];
    }

    const [lastPanel] = Array.from(explorer.querySelectorAll('.panel:not(.main):not(.details)')).slice(-1)
    let lastPanelSelection = Array.from(lastPanel.querySelectorAll('label.selected'))

    if(lastPanelSelection.length === 0) {
        lastPanelSelection = Array.from(selection).slice(-1) as Array<HTMLElement>;
    }

    let subsequentlySelectedFiles = []

    for(let lastSelected of Array.from(lastPanelSelection)) {
        let path = (lastSelected as HTMLElement).dataset.path?.split('/') as Array<string>

        let sub = getSubFileArray(path, glob)

        if(sub.children.length > 0) {
            let files = Array.from(sub.children)

            while (files && files.length > 0) {
                let file = files.pop()!;
                if (file.children && file.children.length > 0) { //folder
                    files = [...files, ...Array.from(file.children)]
                    continue
                }
                subsequentlySelectedFiles.push(file)

            }
        } else {
            subsequentlySelectedFiles.push(sub)
        }
    }

    return subsequentlySelectedFiles
}

export const SEPARATOR = '|||'
function prepareFileTree(data: Array<FileData>): NestedFileArray {

    // const filePaths = data.map(x => ({name: `/${x.transfer_name || 'Transfer ' + x.prefix}/${x.filename}`, value: x}))
    const filePaths = data.map(x => ({name: `/${x.prefix}/${x.filename}${SEPARATOR}${x.name}`, value: x}))
    const glob = {name: '/', children: [], value: undefined};
    const symbol = Symbol("lookup"); //"/" /* or Symbol("lookup") in modern browsers */;
    const lookup = {[symbol]: glob};

    filePaths.forEach((item: { name: string, value: any }) => {
        item.name.split("/").slice(1).reduce(function (dir: any, sub) {  // slice: remove prefix amd file suffix
            if (!dir[sub]) {
                let subObj = {name: sub, value: item.value, children: []};
                dir[symbol].children.push(subObj);
                return dir[sub] = {[symbol]: subObj};
            }
            return dir[sub];
        }, lookup);

    });
    return glob;
}


const triggerClick = (element: HTMLElement, shiftkey: boolean) => {
    const event = new MouseEvent('click', {shiftKey: shiftkey, bubbles: true})
    element.dispatchEvent(event)
}

const next =(current: HTMLElement, direction: string, explorer: HTMLElement): HTMLLIElement | null => {
    const li = current.parentElement;
    switch(direction) {
        case 'up':

            let nextElement = li!.previousSibling as HTMLLIElement
            let lastElement: HTMLLIElement | null = null;
            if(nextElement) {
                while (nextElement && nextElement.querySelector('.selected')) {
                    nextElement = nextElement.previousSibling as HTMLLIElement
                    if(nextElement) {
                        lastElement = nextElement;
                    }
                }
            }
            if(nextElement) {
                return nextElement as HTMLLIElement;
            }
            return lastElement;
        case 'down':
            if (li!.nextSibling) {
                return li!.nextSibling as HTMLLIElement;
            }
            return li as HTMLLIElement

        case 'left':
            if(explorer.querySelectorAll('.selected').length > 1) {
                current.classList.remove('selected')
            }
            const prevPanel = li!.closest('.panel')!.previousSibling as HTMLDivElement;
            if(prevPanel) {
                const selectedLabel = prevPanel.querySelector('label.selected')
                if (selectedLabel) {
                    return selectedLabel.parentElement as HTMLLIElement;
                }
                return prevPanel.querySelector('li') as HTMLLIElement;
            }
            break;
        case 'right':
            const nextPanel = li!.closest('.panel')!.nextSibling as HTMLDivElement;
            if(nextPanel) {
                return nextPanel.querySelector('li') as HTMLLIElement;
            }
            break;
        default:
            return null
    }
    return null;

}


const chain = (direction: string, shiftKey: boolean) => {
    const explorer = document.getElementById('transfer-file-list') as HTMLElement;  // must be seeked again
    if(!explorer) {
        return;
    }
    let selected = explorer.querySelectorAll('.panel .selected')

    if(selected.length === 0) { // any arrow key selects the first
        let firstPanel = explorer.querySelector('.panel')
        let label = firstPanel!.querySelector('label')
        if (label) {
            triggerClick(label, shiftKey)
        }
    } else {
        const secondLastSelected = selected[selected.length - 1];
        const nextElement = next(secondLastSelected as HTMLElement, direction, explorer)
        if(nextElement) {
            const label = nextElement.querySelector('label')
            if(label) {
                triggerClick(label, shiftKey)
            }
        }
    }
}
function setupKeyboardShortcuts(db: IDBDatabase) {

    const explorer = document.getElementById('transfer-file-list');
    if(!explorer) {
        return
    }

    document.onkeydown = function(e) {
        const target = e.target as HTMLElement
        if(target.tagName.toLowerCase() === 'input') {
            return
        }
        const dont = ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"]
        if (dont.indexOf(e.key) >= 0) {
            e.preventDefault()

        }
    }

    /**
     * Make the keyboard shortcuts for the explorer
     */
    document.onkeyup = function (e) {
        const target = e.target as HTMLElement
        if(target.tagName.toLowerCase() === 'input') {
            return
        }
        if(target.tagName.toLowerCase() === 'textarea') {
            return;
        }

        // prevent shortcuts if a modal is open
        const modals = document.querySelectorAll('.gmodal-active');
        if(modals.length > 0) {
            return;
        }


        switch (e.key) {
            case "ArrowDown":
                e.preventDefault()
                chain('down', e.shiftKey)
                break;
            case "ArrowUp":
                e.preventDefault()
                chain('up', e.shiftKey)
                break;
            case "ArrowLeft":
                e.preventDefault()
                chain('left', e.shiftKey)
                break;
            case "ArrowRight":
                e.preventDefault()
                chain('right', e.shiftKey)
                break;
            case "R":
            case "r":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                renameTransfer()
                break;
            case "A":
            case "a":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                archiveTransfer()
                break;
            case "U":
            case "u":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()

                unarchiveTransfer()
                break;
            case "C":
            case "c":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                getShareLink(db)
                break;
            case "S":
            case "s":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                reshare()
                break;
            case "E":
            case "e":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                emailLink()
                break;
            case "T":
            case "t":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                deleteFiles()
                break;
            case "F":
            case "f":
                const searchInput = document.getElementById('search-input')
                if(searchInput) {
                    searchInput.focus()
                }
                break;
            case "D":
            case "d":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                downloadFiles()
                break;
            case "0":
                if(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
                    break;
                }
                e.preventDefault()
                document.getElementById('open-uppy-button')!.click()
                break;
            case "1":
            case "2":
            case "3":
                e.preventDefault()
                const mapping = {
                    '1': 'sent-button',
                    '2': 'received-button',
                    '3': 'archive-button'
                }
                const sidebarButton = document.getElementById(mapping[e.key]);
                if(sidebarButton) {
                    sidebarButton.click()
                }
                break;
            case "?":
            case "H":
            case "h":
                const link = document.getElementById('help-link')
                if(link) {
                    link.click()
                }
                break;

        }
    };
}

interface NestedFileArray {
    name: string,
    value: FileData | undefined,
    children: Array<NestedFileArray>
}


function getFileType(elem: NestedFileArray): Array<string> {

    if(elem.children && elem.children.length > 0) {

        if(elem.value!.password_hash.toString() === 'true') {
            return ['folder', 'folder-lock']
        }

        return ['folder']
    }

    const filename = elem.value!.filename;

    const extension = filename!.split('.').slice(-1)[0]
    switch(extension.toLowerCase()) {
        case "jpg":
        case "jpeg":
        case "png":
        case "svg":
        case "gif":
        case "psd":
            return ['file', 'file-image']
        case "pdf":
            return ['file', 'file-pdf']
        case "zip":
        case "tar":
        case "rar":
        case "7z":
            return ['file', 'file-archive']
        case "m4a":
        case "flac":
        case "mp3":
        case "wav":
        case "wma":
        case "aac":
            return ['file', 'file-audio']
        case "doc":
        case "docx":
            return ['file', 'file-word']
        case "xls":
        case "xlsx":
            return ['file', 'file-excel']
        case "ppt":
        case "pptx":
            return ['file', 'file-powerpoint']
        case "mp4":
        case "mov":
        case "wmv":
        case "avi":
        case "avchd":
        case "flv":
        case "webm":
        case "mkv":
            return ['file', 'file-video']
    }
    return ['file']
}


const isToday = (someDate: Date) => {
  const today = new Date()
  return someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
}

function renderContextButton(prefix: string, label: HTMLLabelElement) {
    // const contextOuter = createElemWithClasses('div', ['ms-auto', 'position-relative']) as HTMLDivElement;
    const contextMenuButton = createElemWithClasses('a', ['ms-auto', 'context-menu']) as HTMLAnchorElement;
    contextMenuButton.id = `context-menu-${prefix}`

    // contextMenuButton.dataset.bsToggle = "dropdown"
    // contextMenuButton.ariaExpanded = "false"


    const contextMenuIcon = createElemWithClasses('img') as HTMLImageElement;
    if (label.classList.contains('from-me')) {
        contextMenuIcon.src = '/img/icons/outline/menu-vertical-white.svg';
    } else {

        contextMenuIcon.src = '/img/icons/outline/menu-vertical.svg';
    }
    contextMenuButton.appendChild(contextMenuIcon)



    return contextMenuButton
}




function renderContextMenu() {
    const contextOuter = createElemWithClasses('div', ['context-menu-inline', 'ms-auto', 'position-relative']) as HTMLDivElement;

    const contextMenu = createElemWithClasses('ul') as HTMLAnchorElement;
    // @ts-ignore
    contextMenu.ariaLabelledby = "dropdownMenuLink"

    renderActions(contextMenu)


    contextOuter.appendChild(contextMenu)

    return contextOuter;
}

function renderListPanel(list: NestedFileArray, path: Array<string>, level: number = 0) {
    const fileList = createElemWithClasses('ul', []);

    let sortedChildren
    if(level === 0) {
        sortedChildren = list.children.sort((a, b) => a.value!.create_date - b.value!.create_date)

    } else {
        sortedChildren = list.children.sort((a, b) => a.value!.filename!.localeCompare(b.value!.filename!))
    }

    sortedChildren.forEach(elem => {
        const id = `${elem.value!.prefix}-${elem.value!.name}`;  // make it unique with filehash and prefix

        const value = elem.value as FileData

        let label = createElemWithClasses('label') as HTMLLabelElement;

        // let nItems = elem.children.length;

        let nItems = 0;
        const objectLength = (obj: any) => {
            for (let value of Object.values(obj.children)) {
                if (typeof value == 'object') {
                    // nItems++;
                    objectLength(value);
                }
                if((value as any).children.length === 0) {
                    nItems++;
                }
            }
        }
        objectLength(elem)

        let nItemsString = `${nItems} ${nItems > 1 ? translate('Files'): translate('File')}`
        const numChildren = elem.children.length;
        // ? elem.value!.transfer_name + ` - (${nItemsString})` : nItemsString
        let transferName = elem.value!.transfer_name || '';
        if(transferName) {
            nItemsString = ' - ' + nItemsString;
        }
        const labelText = level === 0 ? transferName : elem.name.split(SEPARATOR)[0];

        const tableMode = document.getElementById('table_mode')! as HTMLInputElement;

        const outerTitle = createElemWithClasses('div', ['d-flex', 'outer-transfer-name']);

        const innerLabel = createElemWithClasses('div', ['inline-label']);
        innerLabel.innerText = labelText;
        outerTitle.appendChild(innerLabel)
        const numItemsDiv = createElemWithClasses('div', ['inline-num-files']);
        if(numChildren > 0) {
            numItemsDiv.innerText = nItemsString
            outerTitle.appendChild(numItemsDiv)
        }
        label.appendChild(outerTitle)



        label.id = id;

        if(level === 0) {

            if (tableMode.value === 'inbox' || tableMode.value === 'drive' || tableMode.value === 'outbox' || tableMode.value === 'external_download') {
                let sender_uid = document.getElementById("sender-uid") as HTMLInputElement;
                if(value.from_uid === sender_uid.value) {  // upload
                    label.classList.add('from-me')
                } else {
                    label.classList.add('from-else')
                }
            } else {
                 if(value.from_uid === tableMode.value ) {  // upload
                    label.classList.add('from-else')
                } else {
                    label.classList.add('from-me')

                }
            }
        }





        // label.dataset.name = `level-${level}`;
        label.dataset.path = `${path.join('/')}/${elem.name}`;
        label.dataset.filename = elem.value!.filename as string;
        label.dataset.level = level.toString();
        label.dataset.prefix = value.prefix;
        label.dataset.name = value.name;
        label.dataset.expiry = value.expiry;
        label.dataset.download_count = value.download_count.toString();
        label.dataset.downloads = value.downloads;
        label.dataset.encryptedkey = value.encryptedkey;
        label.dataset.size = value.size.toString();
        label.dataset.message = value.message || '';


        const classList = getFileType(elem)
        let li = createElemWithClasses('li', classList);
        li.appendChild(label);

        const footer = createElemWithClasses('div', ['d-flex', 'align-items-baseline'])

        const dateDiv = createElemWithClasses('div', ['explorer-item-detail'])
        if(level === 0) {
            dateDiv.classList.add('ms-auto')
            dateDiv.classList.add('me-2')
        }
        // let nitems = ''
        // footer.append(details)



        if(level === 0) { // a folder
            const createDate = new Date(elem!.value!.create_date);
            // const date = createDate.toLocaleDateString()
            const time = createDate.toLocaleTimeString()
            let showDate = createDate.toLocaleDateString();
            if (isToday(createDate)) {
                showDate = time
            }
            // const itemString = translate(`item${(numChildren === 1 ? '' : 's')}`);

            dateDiv.innerText = showDate; // note: save innerHtml
            // nitems = `${numChildren} ${itemString}`
        } else { // a file
            const expiresString = translate('Expires in');
            dateDiv.innerText = `${expiresString} ${elem.value!.expiry} - ${elem.value!.size} - ${elem.value!.downloads}`;
            // nitems = ``
        }

        if(level === 0) {
            const mode = tableMode.value;
            if (mode !== 'outbox' && mode !== 'external_download') {
                if(!label.classList.contains('from-me') && !isUserView()) {
                    const from = createElemWithClasses('div', ['explorer-item-from'])
                    from.innerText = `From: ${elem.value!.from_raw}`
                    label.append(from)
                }

            }
            if (mode === 'outbox') {
                const to = createElemWithClasses('div', ['explorer-item-from'])
                if (elem.value!.to_raw) {
                    to.innerText = `To: ${elem.value!.to_raw}`
                    label.append(to)
                }
            }

            if(value.message) {
                let messageDiv = createElemWithClasses('div', ['inline-message'])
                messageDiv.innerHTML = '<img src="/img/icons/uppy/message-left-white.svg" alt="Message" class="message-link">';  // note: save innerHtml
                let innerMessage = createElemWithClasses('span')
                innerMessage.innerText = value.message;  // note: save innerHtml
                messageDiv.append(innerMessage);

                label.append(messageDiv)
            }

        }

        footer.appendChild(dateDiv)
        // label.appendChild(nitems)
        if(level === 0) {
            // const checks = createElemWithClasses('div', ['chat-checks', 'd-flex'])
            const innerChecks = createElemWithClasses('div', ['chat-checks'])
            // checks.appendChild(innerChecks)

            const check1 = createElemWithClasses('img') as HTMLImageElement;
            const check2 = createElemWithClasses('img') as HTMLImageElement;
            check1.width = 12;
            check2.width = 12;
            // let message = '';


            if (elem.value!.download_count >= 1) {
                check1.src = "/img/icons/outline/check-small-green.svg";// alt="Check" width="12"><img src="/img/icons/outline/check-small-green.svg" alt="Check" width="12">`
                check2.src = "/img/icons/outline/check-small-green.svg";
                // message = translate('Downloaded')
            } else {
                if(label.classList.contains('from-me')) {
                    check1.src = "/img/icons/outline/check-small-white.svg"; //alt="Check" width="12"><img src="/img/icons/outline/check-small-gray.svg" alt="Check" width="12">`
                    check2.src = "/img/icons/outline/check-small-white.svg"
                } else {
                    check1.src = "/img/icons/outline/check-small-gray.svg"; //alt="Check" width="12"><img src="/img/icons/outline/check-small-gray.svg" alt="Check" width="12">`
                    check2.src = "/img/icons/outline/check-small-gray.svg"
                }

                // message = translate('Sent')
            }
            innerChecks.appendChild(check1)
            innerChecks.appendChild(check2)
            // innerChecks.addEventListener('mouseenter', () => {
            //     showError(innerChecks, message, 'bottom-end')
            // })

            footer.appendChild(innerChecks)
        }

        const contextButton = renderContextButton(elem.value!.prefix, label);


        outerTitle.appendChild(contextButton)

        label.appendChild(footer)
        // li.draggable = true;
        fileList.appendChild(li);
        // li.addEventListener('dragstart', dragStart)
    })



    return fileList;
}

// noinspection JSUnusedLocalSymbols
const dragStart = (e: any) => {
    const target = e.target as HTMLElement;
    const label = target.querySelector('label');

    const panel = label!.closest('.panel');

    const selection = panel!.querySelectorAll('label.selected');

    if (selection.length > 1) {
        // target.appendChild('Multi')
    }
    //
    //  // Add this element's id to the drag payload so the drop handler will
    // // know which element to add to its tree
    // const dataList = e.dataTransfer.items;
    // dataList.clear()
    // dataList.add(e.target.id, "text/plain");
    // // Add some other items to the drag payload
    // dataList.add("<p>... paragraph ...</p>", "text/plain");
    // dataList.add("http://www.example.org","text/plain");
    //


    e.dataTransfer.setData("elementid", label!.id);
}


// function renderUnread(files: NestedFileArray, tableMode: string): string {
//
//     if(tableMode !== 'inbox') {
//         return ''
//     }
//     // let stack = [files]
//     // if(files.children.length) {
//     //     stack = Array.from(files.children)  // copy!
//     // }
//
//     // let hasUnread = true
//     // while(stack.length > 0) {
//     //     const elem = stack.pop()
//     //     if(elem!.children.length > 0) {
//     //         stack.concat(Array.from(elem!.children))
//     //         continue
//     //     }
//     //     if(elem!.value!.download_count > 0) {
//     //         hasUnread = false
//     //         break
//     //     }
//     // }
//     //
//     // if(hasUnread) {
//     //     return '<span class="unread-dot"></span>'
//     // }
//     return ''
//
// }

const dragEnter = (e: any) => {
    if(e.target.classList.contains('data-drop-target')) {
        e.target.classList.add('highlight')
    }
    const closest = e.target.closest('li');
    if(closest && closest.classList.contains('folder')) {
        e.target.classList.add('highlight')
        console.log('f')
    }
    console.log(e.target)
}
const dragLeave = (e: any)  => {
    if(e.target.classList.contains('data-drop-target')) {
        e.target.classList.remove('highlight')
    }
    const closest = e.target.closest('li');
    if(closest && closest.classList.contains('folder')) {
        e.target.classList.remove('highlight')
        console.log('f')
    }
}
const dragOver = (e: any) =>  {
    if(e.target.classList.contains('data-drop-target')) {
        e.preventDefault()
    }
    const closest = e.target.closest('li');
    if(closest && closest.classList.contains('folder')) {
        e.preventDefault()
    }
}

function moveFile(source: HTMLElement, target: any) {
    const sourcePath = source.dataset.path;
    const targetPath = target.dataset.path;

    const sourceFilename = sourcePath!.split('/').slice(-1)

    console.log(`Move ${sourcePath} to ${targetPath}/${sourceFilename}`)

}

const itemDrop = (e: any) =>  {
    const target = e.target;
    if(target.classList.contains('data-drop-target')) {
        target.classList.remove('highlight')
        let ul = target.querySelector('ul')
        const id = e.dataTransfer.getData("elementid")

        const label = document.getElementById(id)!;
        label.classList.remove('selected')
        let listItem = label.closest('li')!;
        let panel = listItem.closest('.panel')
        if(panel === target) {  // do not drop onto itself
            return false;
        }
        ul.appendChild(listItem)
        moveFile(label, target)
        return true;
    }
    const closest = target.closest('li');
    if(closest && closest.classList.contains('folder')) {
        console.log('move to folder')
        e.target.classList.remove('highlight')
        const id = e.dataTransfer.getData("elementid")
        const label = document.getElementById(id)!;
        moveFile(label, target)
        return true;
    }
    return false;

}

function createPanel(): HTMLDivElement {
    let nextPanel = createElemWithClasses('div', ['panel', 'data-drop-target']) as HTMLDivElement;

    nextPanel.addEventListener('dragenter', dragEnter, false)
    nextPanel.addEventListener('dragleave', dragLeave, false)
    nextPanel.addEventListener('dragover', dragOver, false)
    nextPanel.addEventListener('drop', itemDrop, false)

    return nextPanel;
}



function getSubFileArray(path: string[], glob: NestedFileArray): NestedFileArray {
    let files = glob;
    for (let i=0; i<path.length; i++) {
        let p = path[i]
        if (p === "") {
            continue
        }

        if(files && files.children.length > 0) {
            files = files.children.filter(t => t.name === p)[0];
        }
    }
    return files;
}

//
// function deleteSubFileArray(path: string[], glob: NestedFileArray) {
//     let files = glob;
//     let parent = undefined
//     for (let p of path) {
//         if (p === "") {
//             continue
//         }
//         parent = files
//         files = files.children.filter(t => t.name === p)[0];
//     }
//
//     if(parent) {
//         parent.children = parent.children.filter(x => x.name !== files.name)
//         const label = document.getElementById(path.join('/'))
//         if(label) {
//             label.remove()
//         }
//         //todo check for parent folder?
//     }
//
//
// }



function renderActions(menu: HTMLElement) {

    const explorer = document.getElementById('transfer-file-list')!;
    const selection = explorer.querySelectorAll('label.selected');

    // if(selection.length === 0) {
    //     return;
    // }

    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if(!tableMode) {
        return;
    }

    const renderDownloadButton = () => {
        const label = translate('Download')
        return `
            <div class="d-flex">
                <a href="#" class="action-button" id="action-button-download"><img src="/img/icons/outline/download.svg" alt="${label}">${label}</a>                
                <span class="shortcut ms-auto">D</span>
            </div>
        `
    }
    const renderDeleteButton = () => {
        const label = translate('Trash')
        return `
            <div class="d-flex">
                <a href="#" class="action-button" id="action-button-delete"><img src="/img/icons/outline/trash-1.svg" alt="Trash">${label}</a>                
                <span class="shortcut ms-auto">T</span>
            </div>
        `
    }
    const renderEmailButton = () => {
        if(selection.length !== 1) {
            return '';
        }
        if(tableMode.value === 'drive') {
            return ''
        }
        const label = translate('Email Link')
        return `
            <div class="d-flex">
                <a href="#" class="action-button" id="action-button-email"><img src="/img/icons/outline/at-email.svg" alt="Email">${label}</a>                
                <span class="shortcut ms-auto">E</span>
            </div>         
        `
    }
    const renderCopyButton = () => {
        if(selection.length !== 1) {
            return '';
        }
        if(tableMode.value === 'drive') {
            return ''
        }

        const label = translate('Copy Link')
        return `
            <div class="d-flex">
                <a href="#" class="action-button" id="action-button-copy-link"><img src="/img/icons/outline/link.svg" alt="Copy Link">${label}</a>                
                <span class="shortcut ms-auto">C</span>
            </div>       
        `
    }
    const renderReshareButton = () => {
        if(selection.length === 0) {
            return '';
        }
        if(tableMode.value === 'drive') {
            return ''
        }
        const label = translate('Share with contact')
        return `
            <div class="d-flex">
                <a href="#" class="action-button" id="action-button-reshare"><img src="/img/icons/outline/share-2.svg" alt="Copy Link">${label}</a>                
                <span class="shortcut ms-auto">S</span>
            </div>       
        `
    }
    const renderArchiveButton = () => {
        const tableMode = document.getElementById('table_mode') as HTMLInputElement;

        const labelArchive = translate('Archive');
        const labelUnarchive = translate('Unarchive');

        if(tableMode.value === 'drive') {
            return `
                <div class="d-flex">
                    <a href="#" class="action-button" id="action-button-unarchive"><img src="/img/icons/outline/package.svg" alt="Unarchive">${labelUnarchive}</a>                
                    <span class="shortcut ms-auto">U</span>
                </div>         
            `
        } else {
            return `
                <div class="d-flex">
                    <a href="#" class="action-button" id="action-button-archive"><img src="/img/icons/outline/package.svg" alt="Archive">${labelArchive}</a>                
                    <span class="shortcut ms-auto">A</span>
                </div>         
            `
        }


    }
    const renderRenameButton = () => {
        // const [lastPanel] = Array.from(explorer.querySelectorAll('.panel:not(.main):not(.details)')).slice(-1)
        // const lastPanelSelection = lastPanel.querySelectorAll('label.selected')
        // if(lastPanelSelection.length > 1) {
        //     return '';
        // }
        const label = translate('Rename')
        return `
            <div class="d-flex">
                <a href="#" class="action-button" id="action-button-rename"><img src="/img/icons/outline/edit-1.svg" alt="Rename">${label}</a>                
                <span class="shortcut ms-auto">R</span>
            </div>
        `
    }

    const actionsFuncs = [
        renderDownloadButton,
        renderCopyButton,
        renderEmailButton,
        renderRenameButton,
        renderReshareButton,
        renderArchiveButton,
        renderDeleteButton
    ]

    // for(let actionFunc of actionsFuncs) {

    // }
    actionsFuncs.forEach(actionFunc => {
        const buttonDiv = createElemWithClasses('div', ['action-item'])
        const contents = actionFunc()
        if(!contents) {
            return
        }
        buttonDiv.innerHTML = contents; // note: safe innerHtml
        menu.append(buttonDiv)

    })

}


function renderContactHeader(contact: HTMLElement) {
    const user = document.querySelector('.chat-user')! as HTMLElement
    user.innerText = ''
    const header = createElemWithClasses('div');
    user.appendChild(header)
    const deleteButton = createElemWithClasses('img', ['ms-auto', 'cursor-pointer']) as HTMLImageElement;
    deleteButton.src = "/img/icons/outline/trash-1.svg"
    user.appendChild(deleteButton)
    header.innerText = contact!.innerText.trim();
    deleteButton.addEventListener('click', deleteContact)

}

function createMainPanel(explorer: HTMLElement, glob: NestedFileArray) {
    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if (!tableMode) {
        return
    }
    // create base panel
    const mainPanel = createPanel();
    mainPanel.classList.add('main')
    explorer.appendChild(mainPanel);
    mainPanel.dataset.name = glob.name;
    mainPanel.dataset.path = JSON.stringify([]);
    const fileList = renderListPanel(glob, []);

    const isUserView = !(tableMode.value === 'inbox' || tableMode.value === 'drive' || tableMode.value === 'outbox' || tableMode.value === 'external_download');
    const contact = document.querySelector('.sidebar-button.active') as HTMLElement

    if (isUserView) {
        renderContactHeader(contact);
        // mainPanel.append(user)
    }

    mainPanel.appendChild(fileList);

    renderUploadBUtton(isUserView, tableMode, mainPanel, contact);


    explorer.appendChild(mainPanel);
    const lastItem = fileList.lastChild as HTMLLIElement;
    if(fileList && lastItem) {
        const defaultMargin = parseInt(window.getComputedStyle(lastItem, null).getPropertyValue('margin-bottom'));
        mainPanel.scrollTo(0, mainPanel.scrollHeight - lastItem.getBoundingClientRect().height - defaultMargin * 2);
    }
    // renderDetailPanel(explorer);
}


function setupTableModeButtons(db: IDBDatabase) {
    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if (!tableMode) {
        return
    }
    const uploadedButton = document.getElementById('sent-button');
    const receivedButton = document.getElementById('received-button');
    const archivedButton = document.getElementById('archive-button');

    const setActiveButton = (button: HTMLElement) => {
        document.querySelectorAll('.sidebar-button').forEach((value) => value.classList.remove('active'))
        uploadedButton!.classList.remove('active')
        receivedButton!.classList.remove('active')
        archivedButton!.classList.remove('active')
        button.classList.add('active')
    }
    const headerDiv = document.getElementById('filelist-header')! as HTMLElement
    const innerHeader = document.querySelector('.chat-user')! as HTMLElement
    if(headerDiv) {
        headerDiv.append(innerHeader)
    }


    if(uploadedButton) {

        innerHeader.innerText = uploadedButton.childNodes[0].textContent!;
        uploadedButton.addEventListener('click', (e) => {
            e.preventDefault();
            // innerHeader.innerText = ""
            // headerDiv.innerText = ''
            // headerDiv.append(innerHeader)
            innerHeader.innerText = uploadedButton.childNodes[0].textContent!.trim();
            tableMode.value = 'outbox';
            console.log('tablemode ' + tableMode.value)
            setActiveButton((e.target as HTMLElement).closest('.sidebar-button') as HTMLElement)
            getData(db).then(() => {
            })
            setupNewTable(db).then(() => {
            });
        })
    }
    if(receivedButton) {
        receivedButton.addEventListener('click', (e) => {
            e.preventDefault();
            // innerHeader.innerText = ""
            // headerDiv.innerText = ''
            // headerDiv.append(innerHeader)
            innerHeader.innerText = receivedButton.childNodes[0].textContent!.trim();
            tableMode.value = 'inbox';
            console.log('tablemode ' + tableMode.value)
            setActiveButton((e.target as HTMLElement).closest('.sidebar-button') as HTMLElement)
            getData(db).then(() => {
            })
            setupNewTable(db).then(() => {
            });
        })
    }
    if(archivedButton) {
        archivedButton.addEventListener('click', (e) => {
            e.preventDefault();
            // innerHeader.innerText = ""
            // headerDiv.innerText = ''
            // headerDiv.append(innerHeader)
            innerHeader.innerText = archivedButton.childNodes[0].textContent!.trim();
            tableMode.value = 'drive';
            console.log('tablemode ' + tableMode.value)
            setActiveButton((e.target as HTMLElement).closest('.sidebar-button') as HTMLElement)
            getData(db).then(() => {
            })
            setupNewTable(db).then(() => {
            });
        })
    }

}

function renameTransfer() {
    triggerEvent('arcano-explorer:rename')
}


function processFiles(files: Array<FileData>, url: string, method: string, db: IDBDatabase) {
    const f = files.map(x => x.file_id)
    mfetch(url, {
        method: method,
        body: JSON.stringify(f),
         headers: {
            'Content-Type': 'application/json'
         },
    })
        .then((response) => {
            // if(response.status === 400) {
            //     showArchiveStorageExceeded()
            //     return {}
            // }
            if (response.status === 200) {
                return response.json()
            }
            return {}
        })

        .catch((e) => {
            console.log(e)
        })
        .finally(() => {
            getData(db).then(() => {})
        })
}

function triggerEvent(eventName: string, customData?: {}) {
    let explorer = document.getElementById('transfer-file-list');

    if(!explorer) {
        return
    }
    const event = new CustomEvent(eventName, {detail: customData});
    explorer.dispatchEvent(event);
}

function downloadFiles() {
    triggerEvent('arcano-explorer:download')
}

function deleteFiles() {
    triggerEvent('arcano-explorer:delete')
}

function archiveTransfer() {
    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if(tableMode && tableMode.value !== 'drive') {
        triggerEvent('arcano-explorer:archive');
    }
}

function unarchiveTransfer() {
    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if(tableMode && tableMode.value === 'drive') {
        triggerEvent('arcano-explorer:unarchive');
    }
}

function reshare() {
    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if(tableMode && tableMode.value === 'drive') {
        return
    }
    triggerEvent('arcano-explorer:reshare')
}


function extractShareLink(row: DOMStringMap, forceSingleFile: boolean, db: IDBDatabase): Promise<string> {
    return new Promise((resolve, reject) => {
        if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key
            const onerror = () => {
                reject("")
            }

            const oncomplete = async (event: any) => {
                let key = event.target.result;
                let secret = await extractSecretUsingLocalSecretKey((row.encryptedkey as string), key)
                if (forceSingleFile && secret.includes('?prefix=')) {
                    // inject the 'name' as a query_string arg into the secret
                    const prefixIndex = secret.indexOf('?prefix=');
                    const nameQS = "name=" + row.name + "&";
                    secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
                }

                resolve(secret)

            }
            if (db) {
                getItem(db, 'key', oncomplete, onerror)
            } else {

                const callback = async (modalPassword: string) => {
                    let key = await getSecretKey(modalPassword);
                    if (key) {
                        let secret = await extractSecretUsingLocalSecretKey((row.encryptedkey as string), key)
                        if (forceSingleFile && secret.includes('?prefix=')) {
                            // inject the 'name' as a query_string arg into the secret
                            const prefixIndex = secret.indexOf('?prefix=');
                            const nameQS = "name=" + row.name + "&";
                            secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);

                            // copyTextToClipboard(secret);
                            // showTooltip(tooltipElement, 'Copied!', 'right', 5000)
                            resolve(secret)

                        }
                    } else {
                        showPasswordErrorPrompt(() => {
                            reject("")
                        })

                    }
                };

                passwordPrompt(callback)

            }

        } else {
            reject("")
        }
    })
}

function getShareLink(db: IDBDatabase) {
    if(!isSingleTransferSelected()) {
        return;
    }
    const explorer = document.getElementById('transfer-file-list');
    const selectedTransfer = explorer!.querySelector('label.selected') as HTMLElement
    if(!selectedTransfer) {
        return
    }
    // let tooltipElement = selectedTransfer
    // if(source) {
        // tooltipElement = source
    // }
    const row = {...selectedTransfer!.dataset};
    let forceSingleFile = false;

    async function blobPromise(): Promise<Blob> {
        let secret = await extractShareLink(row, forceSingleFile, db);

        const secretUrl = new URL(secret);
        if(secretUrl.pathname === '/external_download') {
            secretUrl.pathname = `/${getCurrentLang()}${secretUrl.pathname}`;
            secret = secretUrl.toString()
        }

        const blob = new Blob([secret], {type: 'text/plain'})
        return blob
    }

    try { // safari way
        const blob = blobPromise()
        const clip = new ClipboardItem({['text/plain']: blob})
        navigator.clipboard.write([clip]).then(()=>{
            showTooltip(selectedTransfer, 'Copied!', 'right', 5000)
        })

    } catch (e) { // chrome and FF
        extractShareLink(row, forceSingleFile, db).then(secret => {

            const secretUrl = new URL(secret);
            if(secretUrl.pathname === '/external_download') {
                secretUrl.pathname = `/${getCurrentLang()}${secretUrl.pathname}`;
                secret = secretUrl.toString()
            }

            navigator.clipboard.writeText(secret).then(()=>{
                showTooltip(selectedTransfer, 'Copied!', 'right', 5000)
            })
        });
    }



}


function isSingleTransferSelected() {
    const tableMode = document.getElementById('table_mode') as HTMLInputElement;
    if(tableMode && tableMode.value === 'drive') {
        return false
    }

    const explorer = document.getElementById('transfer-file-list');
    if(!explorer) {
        return false
    }
    const selection = explorer.querySelectorAll('label.selected');
    if(selection.length > 1) {
        console.log('nope')
        return false
    }
    return true
}


function emailLink() {

    if(!isSingleTransferSelected()) {
        return
    }

    triggerEvent('arcano-explorer:email-link');
}

function isMobile() {
    const isMobile = window.innerWidth < 768;
    return isMobile;
}

export function sidebarToggleOnMobile(e: Event) {

    const sidebar = document.getElementById('sidebar')!;
    const transfers = document.getElementById('transfers')!;
    if (isMobile() && sidebar && transfers) {
        const target = e.target as HTMLElement
        const parent = target.closest('.sidebar-button') as HTMLAnchorElement
        if (parent && parent.tagName.toLowerCase() === 'a') {
            if (parent.href === window.location.href) {
                e.preventDefault()
            }
            // console.log(parent.href, window.location)
        }

        sidebar.classList.add('hidden')
        transfers.classList.remove('hidden')
    }
}

function setupMobile() {
    const backButton = document.getElementById('file-list-back-button') as HTMLAnchorElement;
    if (backButton) {
        backButton.addEventListener('click', (e) => {
            const explorer = document.getElementById('transfer-file-list')!;
            const panel = explorer.querySelector('.panel')!

            chain('left', e.shiftKey)

            const allPanels = explorer.querySelectorAll('.panel:not(.details)')

            if (allPanels.length <= 2) {
                backButton.style.display = 'none'
            }

            explorer.scrollTo(explorer.scrollLeft - panel.getBoundingClientRect().width, 0);
        })
    }

    const sidebarToggler = document.getElementById('sidebar-toggler-1');
    const sidebar = document.getElementById('sidebar')!;
    const transfers = document.getElementById('transfers')!;


    if (isMobile() && sidebar && transfers) {
        // sidebar.classList.add('hidden')

        transfers.classList.add('one-sidebar-hidden')
        sidebar.classList.add('hidden')

        const sidebarButtons = document.querySelectorAll('.sidebar-button')
        for (let b of sidebarButtons) {
            // b.classList.remove('active')
            b.addEventListener('click', sidebarToggleOnMobile)
        }

        // const sentButton = document.getElementById('sent-button')!;
        // sentButton.classList.remove('active')
        // sentButton.addEventListener('click', () => {
        //     // sentButton.style.d
        //     sidebar.classList.add('hidden')
        //     transfers.classList.remove('hidden')
        // })
        // const receivedButton = document.getElementById('received-button')!;
        // receivedButton.addEventListener('click', () => {
        //     // sentButton.style.d
        //     sidebar.classList.add('hidden')
        //     transfers.classList.remove('hidden')
        // })
        // const archiveButton = document.getElementById('archive-button')!;
        // archiveButton.addEventListener('click', () => {
        //     // sentButton.style.d
        //     sidebar.classList.add('hidden')
        //     transfers.classList.remove('hidden')
        // })
    }

    function toggleSidebars() {
        const sidebarVisible = !sidebar.classList.contains('hidden')

        if (sidebarVisible) {
            transfers.classList.remove('one-sidebar-hidden');
        } else {
            transfers.classList.add('one-sidebar-hidden');
        }
        if (isMobile()) {
            transfers.classList.toggle('hidden')
            // transfers.classList.remove('two-sidebar-hidden');
            // transfers.classList.remove('one-sidebar-hidden');
        }
    }

    if (sidebarToggler) {
        sidebarToggler.addEventListener('click', (e) => {
            e.preventDefault()
            sidebar.classList.toggle('hidden')
            toggleSidebars();
        })
        // activitySidebarToggler.addEventListener('click', (e) => {
        //     e.preventDefault()
        //     messages.classList.toggle('hidden')
        //     toggleSidebars();
        // })
        // closeActivityButton.addEventListener('click', (e) => {
        //     e.preventDefault()
        //     messages.classList.toggle('hidden')
        //     toggleSidebars();
        // })
    }
}

function showHelp() {
    const modalElement = document.getElementById('helpModal')!;
    let myModal = new bootstrap.Modal(modalElement)
    myModal.show()
}

function setupHelp() {
    const link = document.getElementById('help-link')
    if(!link) {
        return
    }
    const modalElement = document.getElementById('helpModal')!;

    link.addEventListener('click', () => {
        showHelp()
    })
    modalElement.addEventListener('show.bs.modal', () => {
        const backdrop = createElemWithClasses('div', ['modal-backdrop', 'show'])
        document.body.appendChild(backdrop)
    })
    modalElement.addEventListener('hide.bs.modal', () => {
        console.log('hide')
    })
}

function setupV2ActionButton(db: IDBDatabase) {

    let explorer = document.getElementById('transfer-file-list');

    if(!explorer) {
        return
    }

    document.addEventListener('click', (e) => {
        const target = e.target as HTMLAnchorElement;

        if (!target.classList.contains('action-button')) {
            return
        }

        const actionId = target.id;
        switch (actionId) {
            case 'action-button-download':
                downloadFiles()
                break
            case 'action-button-delete':
                deleteFiles()
                break
            case 'action-button-email':
                emailLink()
                break
            case 'action-button-copy-link':
                getShareLink(db);
                // navigator.clipboard.writeText('xxxx')
                break
            case 'action-button-reshare':
                reshare()
                break
            case 'action-button-archive':
                archiveTransfer()
                break
            case 'action-button-unarchive':
                unarchiveTransfer()
                break
            case 'action-button-rename':
                renameTransfer()
                break
            default:
                break
        }


    })
}

function setupSearch() {
    let explorer = document.getElementById('transfer-file-list');

    if(!explorer) {
        return
    }
    const searchInput = document.getElementById('search-input') as HTMLInputElement
    if(!searchInput) {
        return
    }

    searchInput.addEventListener('keyup', delay(function () {
        const searchTerm = searchInput.value.toLowerCase();
        console.log(`Searching ${searchTerm}`)
        triggerEvent('arcano-explorer:search', {term: searchTerm})
    }, 500))
    searchInput.addEventListener('search', () => { // event for clearing search
        console.log('search', searchInput.value)
        if(!searchInput.value) {
            triggerEvent('arcano-explorer:search', {term: ""})
        }
    })
}

function setupFileCounters() {
    setInterval(() => {
        updateFileCounters()
    }, 30000)
    updateFileCounters()
}

function setupNoValidSubscription() {
    const noValidSubscription = document.getElementById('no-valid-subscription')
    if(!noValidSubscription) {
        return
    }
    let message = 'Your free trial period is over. Please upgrade to continue Arcano and keep all your files.'
    let title = 'You have no valid subscription'
    if (window.location.pathname.includes('/de/')) {
        title = 'Sie haben kein gültiges Abonnement'
        message = 'Bitte aktualisieren Sie, um Arcano fortzusetzen und alle Ihre Dateien zu behalten.'
    }
    if (window.location.pathname.includes('/fr/')) {
        title = "Vous n'avez pas d'abonnement valide"
        message = 'Veuillez obtenir une nouvelle licence pour continuer à utiliser Arcano et garder vos fichiers'
    }
    upgradePrompt(noValidSubscription.dataset.href!, message, title)
}

function setupReferralLink(){
    const referralButton = document.getElementById('show-referral')
    if (!referralButton){
        return
    }

    referralButton.addEventListener('click',async function(){
        //server call Create the referral coupon code for this user from his uid
        let sender_uid = document.getElementById("sender-uid");
        if(!sender_uid) {
            return
        }
        let code = sender_uid.getAttribute('value')
        let bRef = await mfetch('/get_ref/' + code).then(res => res.text())

        // if(bRef === 'true'){
        //     let link = showReferral()
        //     setupClipboardButtons()
        //     const clipboardRef = document.getElementById('refLinkCopyButton') as HTMLInputElement;
        //     clipboardRef.value = link;
        // }


    })
}

function setupGoodie(){
    const goodieButton = document.getElementById('show-goodie')
    if (!goodieButton){
        return
    }

    goodieButton.addEventListener('click',function(){
        showGoodie()
    });
}

function setupTrialExpired() {
    const trialExpired = document.getElementById('trial-expired')
    if(!trialExpired) {
        return
    }
    let message = 'Your free trial period is over. Please upgrade to continue Arcano and keep all your files.'
    let title = 'Trial expired'
    if (window.location.pathname.includes('/de/')) {
        title = 'Trial abgelaufen'
        message = 'Bitte aktualisieren Sie, um Arcano fortzusetzen und alle Ihre Dateien zu behalten.'
    }
    if (window.location.pathname.includes('/fr/')) {
        title = "Periode d'essai terminé"
        message = 'Veuillez obtenir une nouvelle licence pour continuer à utiliser Arcano etr garder vos fichiers'
    }
    upgradePrompt(trialExpired.dataset.href!, message, title)
}


document.addEventListener("DOMContentLoaded", () => {

    let db: IDBDatabase;
    let dbReq = indexedDB.open('arcano.app', 1);
    dbReq.onupgradeneeded = (event) => {
        // Set the db variable to our database, so we can use it!
        // noinspection JSUnresolvedVariable
        // @ts-ignore
        db = event.target.result;
        // Create an object store
        db.createObjectStore('key', {autoIncrement: true});
    }
    dbReq.onsuccess = function (event) {
        // noinspection JSUnresolvedVariable
        db = (event.target as IDBOpenDBRequest).result;
        setupWithDB(db);

        // handleTransferRenaming(db)
    }
    dbReq.onerror = function () {
        setupWithDB(db);

    }

    if (window.location.pathname.includes('/external_upload')) {
        document.documentElement.className += (window.self === window.top ? " top" : " framed");
    }

    function setupWithDB(db: IDBDatabase) {

        let tableMode = document.getElementById('table_mode') as HTMLInputElement;
        const searchParameters = new URLSearchParams(document.location.search);
        if(searchParameters.has('filter_prefix')) {
            if(searchParameters.has('table_mode')) {
                if (searchParameters.get('table_mode') === 'outbox') {
                    document.getElementById('sent-button')!.classList.add('active')
                    document.getElementById('received-button')!.classList.remove('active')

                } else {
                    document.getElementById('sent-button')!.classList.remove('active')
                    document.getElementById('received-button')!.classList.add('active')
                }
                tableMode.value = searchParameters.get('table_mode')!
            }

            // note: see  abit further below for how to set prefix into search field
        }


        getData(db, searchParameters.get('filter_prefix')!).then(() => {})
        setupNewTable(db).then(() => {});
        initUtils(db);
        setupResetPassword(db)

        setupTableModeButtons(db);
        setupKeyboardShortcuts(db);
        setupV2ActionButton(db);
        setupContacts(db);



    }
    setupForgotPassword()
    setupPluginLink()
    setupDropzone();
    setupClipboardButtons();

    setupLogin();
    setupRegisterUser();

    setupVerification();
    // setupDiscoverable();
    setupDeleteAccount();

    setupMobile();

    setupReceiveSettings()
    setupReferralLink()
    setupGoodie()

    setupFileCounters();

    setupHelp();
    setupSearch();
    setupSettingsForms();

    setupTrialExpired();
    setupNoValidSubscription();

    // setupCookieBanner()
    setupSettingsForms()

    document.addEventListener('click', (e) => {

        const element = e.target as HTMLElement;
        const fired = element.closest('.context-menu')

        document.querySelectorAll('.context-menu-inline').forEach((item) => {

            item.remove()
        })
        document.querySelectorAll('.context-is-open').forEach((item) => {
            item.classList.remove('context-is-open')
        })

        const backdrop = document.querySelector('.modal-backdrop')
        if(backdrop) {
            backdrop.remove()
        }



        if(fired) {
            if(fired.classList.contains('context-menu')) {
                const li = element.closest('label')!
                const menu = renderContextMenu()
                const backdrop = createElemWithClasses('div', ['modal-backdrop', 'show'])
                document.body.appendChild(backdrop)
                li.classList.add('context-is-open')
                li.parentElement!.append(menu)

                const panel = li.closest('.panel')
                console.log(panel)

                // panel.scrollTo(0, panel.scrollHeight - menu.getBoundingClientRect().height);

                menu.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});

            }
        }
    })

    // const audioButton = document.querySelector('[data-uppy-acquirer-id=Audio]') as HTMLElement;
    // if(audioButton) {
    //     audioButton.addEventListener('click')
    // }



});

